import { NetFront } from "@/constants/netEvent.ts";
import { reqGet, reqPost } from "@/service/clientRequest.ts";
import { GetGameWinRecordRsp } from "@/types/swagger/appserver.ts";
import {
  GetGameListReq,
  GetGameListRsp,
  GetLatestGameRecordsReq,
  GetLatestGameRecordsRsp,
  Null,
} from "@/types/swagger/front.ts";

export const postGetGameWinRecord = () => {
  return reqPost<Null, GetGameWinRecordRsp>(
    {},
    NetFront.mod,
    NetFront.GetGameWinRecord,
    false,
  );
};

export const getGetGameList = (data: GetGameListReq) => {
  return reqGet<GetGameListReq, GetGameListRsp>(
    data,
    NetFront.mod,
    NetFront.GetGameList,
    false,
  );
};

export const getGetGameDetail = (data: GetGameListReq) => {
  return reqGet<GetGameListReq, GetGameListRsp>(
    data,
    NetFront.mod,
    NetFront.GetGameDetail,
    false,
  );
};

//投注记录组件获取数据
export const postGameRecords = (data: GetLatestGameRecordsReq) => {
  return reqPost<GetLatestGameRecordsReq, GetLatestGameRecordsRsp>(
    data,
    NetFront.mod,
    NetFront.GetLatestGameRecords,
    false,
  );
};
